import React  from 'react';
import './App.css';
import './Source.css';
import SourceLang from './SourceLang.json';

import { useNavigate } from "react-router-dom";

class SourceChunks extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookJsonObj: null,
			sourceArray: null,
			sourceID: -1,
			chunkArray: null,
		}
	}

	async componentDidMount() {

		var notebookID = this.props.notebookID;
		var sourceIndex = this.props.sourceIndex;

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID);
		var sourceArray = await this.props.serverGetSourceList(notebookID);

		var notebookStorageID = notebookJsonObj.storageID;		
		var itemObj = sourceArray[sourceIndex];
		var sourceID = itemObj.sourceID;
		this.setState({
			notebookJsonObj: notebookJsonObj,
			sourceArray: sourceArray,
			sourceID: sourceID,
		});
		this.serverGetChunkList(sourceID);
	}
	
	async serverGetChunkList(sourceID) {
		
		if (sourceID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getchunklist?sourceid=" + sourceID;
		
		var chunkArray = null;
		
		try {
			var res = await fetch(url);
			chunkArray = await res.json();
		} catch (err) {
		}

		this.setState({
			chunkArray: chunkArray,
		});
	}

	onClickBackToNotebook() {
		var navigate = this.props.navigate;
  		navigate("/notebook");
	}
	
	renderOneChunks(index, itemObj) {
		
		var key = "chunk-" + index;
		var chunkType = itemObj.chunkType;
		var chunkOverlapText = itemObj.chunkOverlapText;
		var chunkText = itemObj.chunkText;
		var sourcePage = itemObj.sourcePage;
		var infoString = "(" + (index+1) + ", " + chunkType + ")";
		
		return (
			<div key={key}>
				<div className="SourceChunksTitle">
					<span style={{color: "gray"}}>{chunkOverlapText}</span>&nbsp;
					{chunkText}&nbsp;
					<span style={{color: "gray"}}>{infoString}</span>
				</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "2px"}}></div>
			</div>
		);
	}

	renderAllChunks() {
		
		var chunkArray = this.state.chunkArray;
		if (chunkArray === null) {
			return;
		}
		
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<chunkArray.length; i++) {
			itemObj = chunkArray[i];
			jsxCode = this.renderOneChunks(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return jsxArray;
	}

	render() {

		var notebookJsonObj = this.state.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}

		var sourceArray = this.state.sourceArray;
		if (sourceArray === null) {
			return;
		}

		var notebookID = this.props.notebookID;
		var sourceIndex = this.props.sourceIndex;
		var notebookTitle = notebookJsonObj.title;
		
		var itemObj = sourceArray[sourceIndex];
		var filenameExt = itemObj.filename;
		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		
		return (
			<div className="SourceChunksTopContainer">
				<div style={{height: "12px"}}></div>
				<div className="SourceChunksTitle"><b>{this.props.getLang(SourceLang, "notebook")}</b>: {notebookTitle}</div>
				<div className="SourceChunksTitle"><b>{this.props.getLang(SourceLang, "source")}</b>: {filename}</div>
				<hr className="NotebookCustomLine" />
				{this.renderAllChunks()}
				<div style={{height: "20px"}}></div>
				<button className="NotebookGreyButton" onClick={() => this.onClickBackToNotebook()}>{this.props.getLang(SourceLang, "backToNotebook")}</button>
				<div style={{height: "30px"}}></div>
			</div>
		);
	}
}

export default function SourceChunksFunction(props) {
	const navigate = useNavigate();
	return <SourceChunks {...props} navigate={navigate} />;
}

